export const CANVAS_BUBBLES_NAMES = {
  updateBackups: 'slideCanvas::updateBackups',
};

export const CANVAS_CONTEXT_MENU_FIXED_POSITION = { x: 0, y: 46 };
export const CANVAS_GROUP_BG_COLOR = '#24F1BA';
export const CANVAS_SCALE = 1.22;
export const BASE_CANVAS_DIMENSIONS = { width: 960, height: 540 }; // Back needed this parameters
export const MAX_CANVAS_DIMENSIONS = { width: 1172, height: 659 };
export const BASE_SCALE = 1.22;
export const CANVAS_DIMENSIONS = { width: 1172, height: 659 };
export const OFFSET_Y_MENU = 85;
export const OFFSET_Y_ROTATION_CONTROL = 35;
export const SELECTORS = {
  topCanvas: '[data-fabric="top"]',
  contextMenu: '[data-js-canvas-context-menu]',
  contextMenuItem: '[data-js-context-menu-item]',
  // Данный селектор используется для того, чтобы не деактивировать активный выделенный объект при клике вне канваса.
  ignoreOutsideClick: '[data-js-ignore-outside-click]',
  canvas: (canvasID: string) => `[data-canvas-id="${canvasID}"]`,
};

// Атрибуты для использования в React компонентах
export const ATTRIBUTES = {
  ignoreOutsideClick: { 'data-js-ignore-outside-click': true },
};

export const ACTIVE_OBJECT_OPACITY = 0.5;

export const SELECTION_STYLES = {
  DEFAULT: {
    borderColor: '#00BA88',
    cornerColor: '#FFFFFF',
    cornerStrokeColor: '#00BA88',
    cornerSize: 10,
    transparentCorners: true,
    cornerStrokeWidth: 2,
    borderOpacityWhenMoving: 0.8,
  },
  HOLLOW_DIAMOND: {
    borderColor: '#00BA88',
    cornerColor: '#FFFFFF',
    cornerStrokeColor: '#00BA88',
    cornerSize: 10,
    transparentCorners: true,
    cornerStyle: 'rect',
    cornerStrokeWidth: 2,
    rotateCorners: true,
    borderOpacityWhenMoving: 0.8,
  },
  HOLLOW_SQUARE: {
    borderColor: '#00BA88',
    cornerColor: '#FFFFFF',
    cornerStrokeColor: '#00BA88',
    cornerSize: 10,
    transparentCorners: true,
    cornerStyle: 'rect',
    cornerStrokeWidth: 2,
    rotateCorners: false,
    borderOpacityWhenMoving: 0.8,
  },
  HOLLOW_CIRCLE: {
    borderColor: '#00BA88',
    cornerColor: '#00BA88',
    cornerStrokeColor: '#00BA88',
    cornerSize: 8,
    transparentCorners: false,
    cornerStyle: 'circle',
    cornerStrokeWidth: 1,
    borderOpacityWhenMoving: 0.8,
  },
} as const;

export const CANVAS_EVENTS = {
  UPDATE_CONTEXT_MENU: 'slideCanvas::updateContextMenu',
  SHOW_UNLOCK_BUTTON: 'slideCanvas::showUnlockButton',
  HIDE_UNLOCK_BUTTON: 'slideCanvas::hideUnlockButton',
  SCROLL_DETECTED: 'slideCanvas::scrollDetected',
  PROGRESSIVE_LOAD_START: 'slideCanvas::progressiveLoadStart',
  PROGRESSIVE_LOAD_COMPLETE: 'slideCanvas::progressiveLoadComplete',
} as const;

export const BULLET = {
  TEXTBOX_WITHOUT_ICON: 'bullet-textbox-without-icon',
  TEXT_ITEM: 'bullet-text-item',
  IMAGE_ITEM: 'bullet-image-item',
  TEXTBOX: 'bullet-textbox',
  GROUP: 'group-bullets',
  GROUP_WITHOUT_ICON: 'bullet-group-without-icon',
  DEFAULT: 'bullet',
} as const;

export const DEFAULT_CANVAS_OPTIONS = {
  preserveObjectStacking: true,
  enableRetinaScaling: true,
  stopContextMenu: true,
};
